// 从@/pages/intelligence/components/TableComponents/SortBy'迁移

import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useMemo } from 'react';
import { Dropdown, List } from 'tea-component';
import './index.scss';
import { arrayToSimpleObj } from '../../utils';
import { useIntl } from 'umi';

// tipText  如果有提示
// title  标题
// svgTip   svg提示

const sortIconMap: any = {
  sort: 'sort-icon',
  asc: 'arrow-big-up',
  desc: 'arrow-big-down',
};

export default function SortBy({
  children,
  sort,
  sortOptions,
  sortChange,
  sortKey = '',
  className = '',
  dropdownProps,
  titleLeft = false,
}: {
  children: any;
  sort: { by: string; order: 'asc' | 'desc' };
  sortKey?: string;
  sortOptions?: Array<{ text: string; value: string }>;
  sortChange: ({ by, order }: { by: string; order: 'asc' | 'desc' }) => void;
  className?: string;
  dropdownProps?: typeof Dropdown;
  titleLeft?: boolean;
}) {
  const sortMap = arrayToSimpleObj(sortOptions || []);
  const { formatMessage } = useIntl();
  const [by, order] = useMemo(() => {
    let map: any = {};
    // 如果sortOptions存在,那么就需要sortMap里找到sortBy才能将sort解构出来
    // 如果不存在,那么只需要sortKey与sort.by相同就可以解构sort了
    if ((sortOptions && sortMap[sort.by]) || sortKey === sort.by) {
      map = sort;
    }
    return [map.by, map.order];
  }, [sort, sortKey, sortOptions]);

  // sort改变的方法
  const changeSort = (item?: { text: string; value: string }) => {
    let localOrder: 'asc' | 'desc' = order === 'desc' ? 'asc' : 'desc';

    const localBy = item?.value || sortKey;

    if (localBy !== sort.by) {
      localOrder = 'desc';
    }

    const changeSortObj = { by: localBy, order: localOrder };

    sortChange(changeSortObj);
  };

  // 多选的泡泡内容
  const menu = useMemo(() => {
    if (!sortOptions || sortOptions.length === 0) {
      return null;
    }
    return (
      <List type="option">
        {sortOptions?.map((item) => {
          const iconKey = item.value === by ? order : 'sort';
          return (
            <List.Item key={item.text} onClick={() => changeSort(item)}>
              <SvgIcon
                type={sortIconMap[iconKey] || 'sort'}
                className="text-icon"
              />
              <span className="option-text-info">{item.text}</span>
            </List.Item>
          );
        })}
      </List>
    );
  }, [sortOptions, by]);

  const isSelected = useMemo(() => {
    return Boolean(sortMap[sort.by]);
  }, [sort]);

  return (
    <div
      className={`dbo-table-header-flex ${
        titleLeft ? '' : 'right'
      } ${className}`}
    >
      <Dropdown
        boxClassName="dbo-sort-by"
        className="dbo-sort-table"
        appearance="pure"
        trigger="hover"
        {...(dropdownProps || {})}
        button={
          <>
            <span className={isSelected ? 'active' : ''}>{children}</span>
            <SvgIcon
              type={sortIconMap[order] || 'icon-arrow-down'}
              className={`table-header-tip  ${
                order === 'desc' || order === 'asc' ? 'action-icon' : ''
              }`}
            />
          </>
        }
      >
        <List type="option">
          <div className="text-desc">{formatMessage({ id: 'Sort By' })}</div>
          {menu}
        </List>
      </Dropdown>
    </div>
  );
}
